import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MasterDataService } from 'src/app/services/master-data.service';
import { MydiaryService } from 'src/app/services/mydiary.service';
import * as moment from 'moment';

@Component({
  selector: 'app-my-pending-submission',
  templateUrl: './my-pending-submission.component.html',
  styleUrls: ['./my-pending-submission.component.css'],
})
export class MyPendingSubmissionComponent implements OnInit {
  selectedFY: any = null;
  financialYearList: any;
  financialYearsWeekList: any;
  financialYearsWeekListConst: any;
  radioSelected: string;

  constructor(
    private masterDataService: MasterDataService,
    private mydiaryService: MydiaryService,
    public router: Router
  ) {}

  ngOnInit(): void {
    console.log('inside ngoninit');
    this.loadFinancialYear();
  }

  loadFinancialYear() {
    this.masterDataService.getFinancialYear().subscribe((res) => {
      console.log(res);
      this.financialYearList = res;
      console.log('table response', res);
      var fyIndex = -1;
      this.financialYearList.forEach((element, key) => {
        var startDate = new Date(element.startDate);
        var endDate = new Date(element.endDate);
        // var currentDate = new Date();
        var currentDate = moment(new Date()).format('YYYY-MM-DD');
        console.log(startDate, endDate);
        console.log(currentDate);
        if (
          currentDate >= element.startDate &&
          currentDate <= element.endDate
        ) {
          fyIndex = key;
        }
      });
      this.selectedFY = this.financialYearList[fyIndex];

      // var max = this.financialYearList.reduce(function(prev, current) {
      //   if (+current.id > +prev.id) {
      //       return current;
      //   } else {
      //       return prev;
      //   }
      // });
      // this.selectedFY = max;
       this.onloadWeeksForFY();


    });
  }

  onloadWeeksForFY() {
    this.financialYearsWeekList = [];
    console.log('financial week array list', this.financialYearsWeekList);

    this.mydiaryService
      .getPendingSubmissionWeeksForFY(this.selectedFY.id)
      .subscribe((res: any) => {
        console.log(res);
        this.financialYearsWeekList = [...res];
        console.log('financial week array list', this.financialYearsWeekList);
        // this.collectionSize = this.financialYearsWeekList.length;
        // this.financialYearsWeekListConst = [...res];
        // this.refreshCollectionList();
      });
  }

  onWeekChange(fyWeek) {
    console.log(fyWeek);
    this.router.navigate(['/dashboard/my-diary'], {
      queryParams: { fyId: this.selectedFY.id, weekOfYear: fyWeek.weekOfYear },
    });
  }
}
